// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MonthlyLimitInfoAPIModel,
    MonthlyLimitInfoAPIModelFromJSON,
    MonthlyLimitInfoAPIModelFromJSONTyped,
    MonthlyLimitInfoAPIModelToJSON,
    OneTimeLimitInfoAPIModel,
    OneTimeLimitInfoAPIModelFromJSON,
    OneTimeLimitInfoAPIModelFromJSONTyped,
    OneTimeLimitInfoAPIModelToJSON,
} from './';

/**
 * 
 * @export
 * @interface LimitSummaryAPIModel
 */
export interface LimitSummaryAPIModel {
    /**
     * 
     * @type {MonthlyLimitInfoAPIModel}
     * @memberof LimitSummaryAPIModel
     */
    monthly?: MonthlyLimitInfoAPIModel;
    /**
     * 
     * @type {OneTimeLimitInfoAPIModel}
     * @memberof LimitSummaryAPIModel
     */
    oneTime?: OneTimeLimitInfoAPIModel;
}

export function LimitSummaryAPIModelFromJSON(json: any): LimitSummaryAPIModel {
    return LimitSummaryAPIModelFromJSONTyped(json, false);
}

export function LimitSummaryAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LimitSummaryAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'monthly': !exists(json, 'monthly') ? undefined : MonthlyLimitInfoAPIModelFromJSON(json['monthly']),
        'oneTime': !exists(json, 'oneTime') ? undefined : OneTimeLimitInfoAPIModelFromJSON(json['oneTime']),
    };
}

export function LimitSummaryAPIModelToJSON(value?: LimitSummaryAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'monthly': MonthlyLimitInfoAPIModelToJSON(value.monthly),
        'oneTime': OneTimeLimitInfoAPIModelToJSON(value.oneTime),
    };
}


